export const messages = {
  en: {
    myItemOutAuditHistoryOrders: {
      page: { title: 'Collection History Orders', subtitle: 'View completed collection audit tasks', empty: 'No history orders found' },
      title: 'Item Out Audit History Orders',
      orderId: 'Order ID',
      orderType: 'Order Type',
      orderStatus: 'Order Status',
      applicant: 'Applicant',
      createTime: 'Create Time',
      operation: 'Operation',
      view: 'View',
      back: 'Back',
      refresh: 'Refresh'
    }
  },
  zh: {
    myItemOutAuditHistoryOrders: {
      page: { title: '领用已办单', subtitle: '查看已完成的领用审核任务', empty: '暂无已办单' },
      title: '领用已办单',
      orderId: '订单号',
      orderType: '订单类型',
      orderStatus: '订单状态',
      applicant: '申请人',
      createTime: '创建时间',
      operation: '操作',
      view: '查看',
      back: '返回',
      refresh: '刷新'
    }
  }
}